import util from '@/util'

const usuarioTemFoto = (objetoFotoUsuario) => {
  if (util.valorVazio(objetoFotoUsuario)) {
    return false
  }
  if (!util.valorVazio(objetoFotoUsuario.codigoBase64) || !util.valorVazio(objetoFotoUsuario.urlExterna)) {
    return verificarUsuarioTemFotoObjetoStream(objetoFotoUsuario)
  }

  return verificarUsuarioTemFotoPeloCodigo(objetoFotoUsuario)
}

const verificarUsuarioTemFotoObjetoStream = (streamFotoUsuario) => {
  if (!util.valorVazio(streamFotoUsuario.codigoBase64)) {
    return verificarUsuarioTemFotoPeloCodigo(streamFotoUsuario.codigoBase64)
  }

  if (!util.valorVazio(streamFotoUsuario.urlExterna)) {
    return true
  }

  return false
}

const verificarUsuarioTemFotoPeloCodigo = (codigoFotoUsuario) => {
  if (codigoFotoUsuario.constructor !== String) {
    return false
  }
  const codigoFotoUsuarioTratado = codigoFotoUsuario.toLowerCase()
  const codigoFotoEhNulo = codigoFotoUsuarioTratado === 'undefined' || codigoFotoUsuarioTratado === 'null'
  const codigoFotoEhVazio = codigoFotoUsuarioTratado === ''

  if (codigoFotoEhNulo || codigoFotoEhVazio) {
    return false
  }

  return true
}

const obterPrimeiroNomeUsuario = (nomeCompleto) => {
  return nomeCompleto.split(' ')[0]
}

export default {
  usuarioTemFoto,
  obterPrimeiroNomeUsuario
}
